import { PudoTransactionVolumeBySpotDonutChart, hasChartSeries } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { usePudoTransactionVolumeBySpotDonutChart } from './use-pudo-transaction-volume-by-spot-donut-chart';

export interface PudoTransactionsBySpotDonutChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

/** PuDo insights card: transaction volume share by SPOT (last 30 days). */
export const PudoTransactionsBySpotDonutChart = ({ accountId, width }: PudoTransactionsBySpotDonutChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading } = usePudoTransactionVolumeBySpotDonutChart(accountId);

    return (
        <InsightCard
            insightId={InsightId.PUDO_TRANSACTIONS_BY_SPOT}
            chartKey={PudoTransactionVolumeBySpotDonutChart.definition.key}
            width={width}
            title={
                <FormattedMessage
                    id='platform.analytics.insights.pudo-transaction-volume-by-spot-donut-chart.title'
                    description='Title for the PuDo transactions-by-SPOT donut chart on analytics insights'
                    defaultMessage='Transactions by SPOT'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.pudo-transaction-volume-by-spot-donut-chart.subtitle'
                    description='Subtitle indicating transactions by SPOT covers the last 30 days of PuDo transaction volume grouped by SPOT'
                    defaultMessage='last 30 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div className='w-full min-w-0'>
                    <PudoTransactionVolumeBySpotDonutChart
                        data={data}
                        showSliceValues
                        showLegend={false}
                        minHeight={chartMinHeight}
                    />
                </div>
            )}
        </InsightCard>
    );
};
